import { getAuthData } from '@common/helpers/auth';
import React from 'react'

const amountsList = [
  100, 200, 1000, 5000
]

export const PredifinedAmounts = ({onSelect, value}) => {
  const { currency } = getAuthData();

  return (
    <div className='predifined-amounts-wrapper'>
      <span>Suggested for you</span>
      <div className='amounts-list'>
        {amountsList.map((amount) => (
          <div className={`amount-item ${+value === +amount ? 'selected' : ''}`} key={amount} onClick={() => onSelect(amount)}>
            {amount} {currency}
          </div>
        ))}
      </div>
    </div>
  )
}